import dayjs from 'dayjs';
import isTodayPlugin from 'dayjs/plugin/isToday';
dayjs.extend(isTodayPlugin);

export const isToday = (date: string) => {
  return dayjs(date).isToday();
};

export const formatDate = (date: string) => {
  return dayjs(date).format('DD.MM.YY');
};
export const formatTime = (date: string) => {
  return dayjs(date).format('HH:mm');
};

export const dateToTime = (date: any, defaultValue = '') =>
  date ? dayjs(date).format('HH:mm') : defaultValue; // EXAMPLE 12:10

export const dateToTimeAMPM = (date: any, defaultValue = '') =>
  date ? dayjs(date).format('HH:mm A') : defaultValue; // EXAMPLE 12:10 PM

export const formatDateAndTime = (date: any, defaultValue = '') =>
  date ? dayjs(date).format('DD-MM-YY HH:mm') : defaultValue; // EXAMPLE 14-08-2020

export const formatTommorowDate = (date: any, defaultValue = '') =>
  date ? dayjs(date).add(1, 'days').format('DD/MM/YY') : defaultValue;

export const formatDay = (date: any, defaultValue = '') =>
  date ? dayjs(date).format('dddd') : defaultValue;

export const formatTommorowDay = (date: any, defaultValue = '') =>
  date ? dayjs(date).add(1, 'days').format('dddd') : defaultValue;

export const monthDiff = (d1: any, d2: any) => {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};
